import { FIELDTYPE_TITLE } from '../constants/api';
import { getAttr, getEntityId, getRelId } from '../features/helpers/apiHelpers';
import { filterAndSortingKeys, noSelectionKey } from './filterAndSortingsUtil';
import { getContentOfTypeFromHearing, getHearingOwner } from './mapHearingItem';

export const filterHearingItems = (
  filterKeys,
  contents,
  fieldTypes,
  fields,
  hearingRoles,
  userHearingRoles,
  users,
) => (hearing) => {
  const hearingOwner = getHearingOwner(
    hearing,
    hearingRoles,
    userHearingRoles,
    users,
  );
  const hearingOwnerResult =
    filterKeys[filterAndSortingKeys.hearingOwner] === noSelectionKey ||
    getEntityId(hearingOwner) === filterKeys[filterAndSortingKeys.hearingOwner];

  const titleContent = getContentOfTypeFromHearing(
    hearing,
    contents,
    fieldTypes,
    fields,
    FIELDTYPE_TITLE,
  )[0]; // This returns a list with 1 item. We unpack that item

  const titleResult =
    filterKeys[filterAndSortingKeys.title] === noSelectionKey ||
    (getAttr(titleContent, 'textContent') &&
      getAttr(titleContent, 'textContent')
        .toLowerCase()
        .includes(filterKeys[filterAndSortingKeys.title].toLowerCase()));

  const hearingStatusResult =
    filterKeys[filterAndSortingKeys.hearingStatus] === noSelectionKey ||
    getRelId(hearing, 'hearingStatus') ===
      filterKeys[filterAndSortingKeys.hearingStatus];

  const hearingTypeResult =
    filterKeys[filterAndSortingKeys.hearingType] === noSelectionKey ||
    getRelId(hearing, 'hearingType') ===
      filterKeys[filterAndSortingKeys.hearingType];

  const subjectAreaResult =
    filterKeys[filterAndSortingKeys.subjectArea] === noSelectionKey ||
    getRelId(hearing, 'subjectArea') ===
      filterKeys[filterAndSortingKeys.subjectArea];

  return (
    hearingStatusResult &&
    hearingTypeResult &&
    subjectAreaResult &&
    hearingOwnerResult &&
    titleResult
  );
};
